import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import classnames from "classnames";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import Modal from "@ignitesales/react-modal";
import startNewGuide from "../utils/startNewGuide.mjs";

const PizzaMenuBox = (props) => {
  const domNode = window.document.getElementsByClassName(
    "app-content-container"
  );
  return ReactDOM.createPortal(
    props.children,
    domNode.length ? domNode[0] : window.document.body
  );
};

//TODO: Make this a generic component that can be used as part of neuro-application - basically need to pass
// props.children into it instead.
const HeaderMenu = (props) => {
  const { className, cloneGuideUrl, newGuideUrl, currentGuideUrl } = props;

  const [opened, setOpened] = useState(false);
  const [restartModalOpen, setRestartModalOpen] = useState(false);
  const box = useRef(null);

  useEffect(() => {
    window.addEventListener("click", onClickOutsideHandler);
    return () => {
      window.removeEventListener("click", onClickOutsideHandler);
    };
  });

  const toggleMenu = (e) => {
    e.stopPropagation();
    setOpened(!opened);
  };

  const onClickOutsideHandler = (e) => {
    if (
      opened &&
      box.current &&
      !box.current.contains(e.target) &&
      !restartModalOpen
    ) {
      setOpened(false);
    }
  };

  const btnClasses = classnames("btn", className);

  const endSession = (url) => {
    if (window.parent !== window) {
      window.close();
    } else {
      document.location = url;
    }
  };

  const restartModal = (
    <Modal
      className="restartModal"
      show={restartModalOpen}
      title={<FormattedMessage id="restartModal.title" />}
      onClose={() => setRestartModalOpen(false)}
      nodeId="root"
      closeBtn={<i className="fa fa-close" />}
    >
      <a href={cloneGuideUrl}>
        <section>
          <FormattedMessage id="restartModal.edit" tagName="h1" />
          <span>
            <FormattedMessage id="restartModal.edit.details" />
          </span>
          <button>
            <FormattedHTMLMessage id="restartModal.button" />
          </button>
        </section>
      </a>
      <a href={newGuideUrl}>
        <section>
          <FormattedMessage id="restartModal.new" tagName="h1" />
          <span>
            <FormattedMessage id="restartModal.new.details" />
          </span>
          <button>
            <FormattedHTMLMessage id="restartModal.button" />
          </button>
        </section>
      </a>
    </Modal>
  );

  return (
    <>
      <button type="button" className={btnClasses} onClick={toggleMenu}>
        <div className="fa fa-bars" />
      </button>
      {opened ? (
        <PizzaMenuBox>
          <div
            ref={box}
            className="pizza-menu-box dropdown-menu dropdown-menu-right"
          >
            <a href={currentGuideUrl} className="dropdown-item">
              <i className="fa fa-undo"></i>
              <span>
                <FormattedMessage id="header.menu-start-over" />
              </span>
            </a>
            <a href={newGuideUrl} className="dropdown-item">
              <i className="fa fa-file"></i>
              <span>
                <FormattedMessage id="header.menu-start-new-guide" />
              </span>
            </a>
          </div>
        </PizzaMenuBox>
      ) : null}
      {restartModal}
    </>
  );
};

HeaderMenu.propTypes = {
  className: PropTypes.string,
  summaryUrl: PropTypes.string,
};

export default connect(({ user }) => {
  return {
    currentGuideUrl: startNewGuide({ user }),
    newGuideUrl: startNewGuide({}),
  };
})(HeaderMenu);
